<div *ngIf="partners.partners$ | ngrxPush as content">
  <div
    (action)="redirect($event)"
    [skeletonMetaData]="{
      loaded: content.loaded,
      error: content.error,
      disabled: content.disabled
    }"
    auraSkeletonLoader
  >
    <idp-partners-ui [content]="content"></idp-partners-ui>
  </div>
</div>
